// DO NOT EDIT THIS FILE. This file auto-generated, use `npm run sync-icons` to update icons
export { ReactComponent as AmericanFootballIcon } from '../svg/americanFootball.svg'
export { ReactComponent as AnimationsIcon } from '../svg/animations.svg'
export { ReactComponent as ArcadeGameIcon } from '../svg/Arcade Game.svg'
export { ReactComponent as ArrowDownRedIcon } from '../svg/arrow-down-red.svg'
export { ReactComponent as ArrowRightShortIcon } from '../svg/arrow-right-short.svg'
export { ReactComponent as ArrowRightIcon } from '../svg/arrow-right.svg'
export { ReactComponent as BadgeIconIcon } from '../svg/Badge-icon.svg'
export { ReactComponent as BalanceProfileIcon } from '../svg/balanceProfile.svg'
export { ReactComponent as BarChartFillIcon } from '../svg/bar-chart-fill.svg'
export { ReactComponent as BaseballIcon } from '../svg/baseball.svg'
export { ReactComponent as BaseballBIcon } from '../svg/baseballB.svg'
export { ReactComponent as BasketballIcon } from '../svg/basketball.svg'
export { ReactComponent as BasketballBIcon } from '../svg/basketballB.svg'
export { ReactComponent as BellSolidIcon } from '../svg/bell-solid.svg'
export { ReactComponent as BombIcon } from '../svg/bomb.svg'
export { ReactComponent as BoxingBIcon } from '../svg/boxingB.svg'
export { ReactComponent as BrandLogoIcon } from '../svg/brand-logo.svg'
export { ReactComponent as BtcLiveIcon } from '../svg/btc-live.svg'
export { ReactComponent as CalendawhiteIcon } from '../svg/calendawhite.svg'
export { ReactComponent as CardArrowIcon } from '../svg/card-arrow.svg'
export { ReactComponent as CasinoLobbyIcon } from '../svg/Casino Lobby.svg'
export { ReactComponent as CasinoMenuIcon } from '../svg/Casino-menu.svg'
export { ReactComponent as CasinoHeadingIcon } from '../svg/casinoHeading.svg'
export { ReactComponent as CasualGameIcon } from '../svg/Casual Game.svg'
export { ReactComponent as CasualDIcon } from '../svg/casual-D.svg'
export { ReactComponent as CasualWIcon } from '../svg/casual-W.svg'
export { ReactComponent as ChatBadgeIconIcon } from '../svg/chat-badge-icon.svg'
export { ReactComponent as ChatBubbleIcon } from '../svg/chat-bubble.svg'
export { ReactComponent as ChatCloseIcon } from '../svg/chat-close.svg'
export { ReactComponent as ChatSportsIcon } from '../svg/chat-sports.svg'
export { ReactComponent as ChatIcon } from '../svg/chat.svg'
export { ReactComponent as CloseBtnIcon } from '../svg/close-btn.svg'
export { ReactComponent as CloseWhiteIcon } from '../svg/closeWhite.svg'
export { ReactComponent as ClutchEcosystemIcon } from '../svg/clutch-ecosystem.svg'
export { ReactComponent as ClutchFullLogoIcon } from '../svg/clutch-full-logo.svg'
export { ReactComponent as ClutchOriginalsDIcon } from '../svg/clutch-originals-D.svg'
export { ReactComponent as ClutchOriginalsWIcon } from '../svg/clutch-originals-W.svg'
export { ReactComponent as ClutchOrignalsIcon } from '../svg/clutch-orignals.svg'
export { ReactComponent as CoinFlipGameIcon } from '../svg/coin-flip-game.svg'
export { ReactComponent as CoingoldIcon } from '../svg/coingold.svg'
export { ReactComponent as ContentLoaderIcon } from '../svg/contentLoader.svg'
export { ReactComponent as CopyIcon } from '../svg/copy.svg'
export { ReactComponent as CrashGameIcon } from '../svg/bus-icon.svg'
export { ReactComponent as CryptoMenuIcon } from '../svg/Crypto-menu.svg'
export { ReactComponent as DepositIcon } from '../svg/Deposit.svg'
export { ReactComponent as DepositProfileIcon } from '../svg/depositProfile.svg'
export { ReactComponent as DiscordIcon } from '../svg/discord.svg'
export { ReactComponent as DragIcon } from '../svg/drag.svg'
export { ReactComponent as EmojiSmileIcon } from '../svg/emoji-smile.svg'
export { ReactComponent as EthIcoIcon } from '../svg/eth-ico.svg'
export { ReactComponent as FavRedWhiteIcon } from '../svg/fav-red-white.svg'
export { ReactComponent as FavStarHeadingIcon } from '../svg/fav-star-heading.svg'
export { ReactComponent as FavouritesDIcon } from '../svg/favourites-D.svg'
export { ReactComponent as FavouritesWIcon } from '../svg/favourites-W.svg'
export { ReactComponent as FifaBIcon } from '../svg/fifaB.svg'
export { ReactComponent as FileIcon } from '../svg/file.svg'
export { ReactComponent as FinancialBettingIcon } from '../svg/Financial betting.svg'
export { ReactComponent as FriendMenuIcon } from '../svg/Friend-menu.svg'
export { ReactComponent as FullScreenIcon } from '../svg/full-screen.svg'
export { ReactComponent as GameInfoIcon } from '../svg/game-info.svg'
export { ReactComponent as GameOnIcon } from '../svg/game-on.svg'
export { ReactComponent as GamesProviderHeadingIcon } from '../svg/games-provider-heading.svg'
export { ReactComponent as GifIcon } from '../svg/gif.svg'
export { ReactComponent as GolfIcon } from '../svg/golf.svg'
export { ReactComponent as GolfBIcon } from '../svg/golfB.svg'
export { ReactComponent as GoogleIconSvgIcon } from '../svg/google-icon-svg.svg'
export { ReactComponent as GoogleLogoIcon } from '../svg/google-logo.svg'
export { ReactComponent as GreenArrowUpIcon } from '../svg/green-arrow-up.svg'
export { ReactComponent as HeaderMenuIconIcon } from '../svg/header-menu-icon.svg'
export { ReactComponent as MenuIcon } from '../svg/menu.svg'
export { ReactComponent as HeaderSearchIcon } from '../svg/header-search.svg'
export { ReactComponent as HeadingStarIcon } from '../svg/heading-star.svg'
export { ReactComponent as HeartFilledIcon } from '../svg/heart-filled.svg'
export { ReactComponent as HiloIcon } from '../svg/hilo.svg'
export { ReactComponent as HiveLoaderSmallIcon } from '../svg/hiveLoaderSmall.svg'
export { ReactComponent as HomeLitIcon } from '../svg/home-lit.svg'
export { ReactComponent as HotkeysIcon } from '../svg/hotkeys.svg'
export { ReactComponent as IceHockeyBIcon } from '../svg/iceHockeyB.svg'
export { ReactComponent as InfinitySvgrepoIcon } from '../svg/infinity-svgrepo.svg'
export { ReactComponent as InfoNewIcon } from '../svg/info-new.svg'
export { ReactComponent as InfoIcon } from '../svg/info.svg'
export { ReactComponent as InstandBetIcon } from '../svg/instand-bet.svg'
export { ReactComponent as IveGreenIconIcon } from '../svg/ive-green-icon.svg'
export { ReactComponent as KenoIcon } from '../svg/keno.svg'
export { ReactComponent as LeftArrowIcon } from '../svg/left-arrow.svg'
export { ReactComponent as LimitIcon } from '../svg/limit.svg'
export { ReactComponent as LinkIcon } from '../svg/link.svg'
export { ReactComponent as LiveCardsIcon } from '../svg/Live Cards.svg'
export { ReactComponent as LiveDiceIcon } from '../svg/Live Dice.svg'
export { ReactComponent as LiveGamesIcon } from '../svg/Live Games.svg'
export { ReactComponent as LiveWheelIcon } from '../svg/Live Wheel.svg'
export { ReactComponent as LiveCasinoDIcon } from '../svg/live-casino-D.svg'
export { ReactComponent as LiveCasinoWIcon } from '../svg/live-casino-W.svg'
export { ReactComponent as LiveIcon } from '../svg/live.svg'
export { ReactComponent as LiveBIcon } from '../svg/liveB.svg'
export { ReactComponent as LoaderIcon } from '../svg/loader.svg'
export { ReactComponent as LobbyDIcon } from '../svg/lobby-D.svg'
export { ReactComponent as LobbyWIcon } from '../svg/lobby-W.svg'
export { ReactComponent as LogoutProfileIcon } from '../svg/logoutProfile.svg'
export { ReactComponent as LotteryIcon } from '../svg/lottery.svg'
export { ReactComponent as MaxBetIcon } from '../svg/max-bet.svg'
export { ReactComponent as MetaColorIcon } from '../svg/meta-color.svg'
export { ReactComponent as MetaIconIcon } from '../svg/meta-icon.svg'
export { ReactComponent as MetaMaskIconNewIcon } from '../svg/meta-mask-icon-new.svg'
export { ReactComponent as MetamaskSquareIcon } from '../svg/metamaskSquare.svg'
export { ReactComponent as MinusIcon } from '../svg/minus.svg'
export { ReactComponent as MobLogoIcon } from '../svg/mob-logo.svg'
export { ReactComponent as MostPlayedIcon } from '../svg/most-played.svg'
export { ReactComponent as MyBetsIcon } from '../svg/myBets.svg'
export { ReactComponent as NewClutchLogoIcon } from '../svg/new-clutch-logo.svg'
export { ReactComponent as NewIconHeadingIcon } from '../svg/new-icon-heading.svg'
export { ReactComponent as NftMenuIcon } from '../svg/Nft-menu.svg'
export { ReactComponent as OriginalsIcon } from '../svg/originals.svg'
export { ReactComponent as OtherGameIcon } from '../svg/Other Game.svg'
export { ReactComponent as PartnerProgramMenuIcon } from '../svg/Partner-Program-menu.svg'
export { ReactComponent as PhantomColorIcon } from '../svg/Phantom-color.svg'
export { ReactComponent as PhantomIconNewIcon } from '../svg/Phantom-icon-new.svg'
export { ReactComponent as PhantomSquareIcon } from '../svg/phantomSquare.svg'
export { ReactComponent as PlinkoIcon } from '../svg/Plinko.svg'
export { ReactComponent as PlusIcon } from '../svg/plus.svg'
export { ReactComponent as PokerDIcon } from '../svg/poker-D.svg'
export { ReactComponent as PokerMenuIcon } from '../svg/Poker-menu.svg'
export { ReactComponent as PokerWIcon } from '../svg/poker-W.svg'
export { ReactComponent as ProbabilityIcon } from '../svg/probability.svg'
export { ReactComponent as ProfileShieldIcon } from '../svg/profile-shield.svg'
export { ReactComponent as ProfileUserIcon } from '../svg/ProfileUser.svg'
export { ReactComponent as ProgressiveGameIcon } from '../svg/Progressive game.svg'
export { ReactComponent as PromoTextIcon } from '../svg/promo-text.svg'
export { ReactComponent as PromotionMenuIcon } from '../svg/Promotion-menu.svg'
export { ReactComponent as RankUpMenuIcon } from '../svg/Rank-up-menu.svg'
export { ReactComponent as ReawardIcon } from '../svg/reaward.svg'
export { ReactComponent as RedLiveCircleIcon } from '../svg/red-live-circle.svg'
export { ReactComponent as RedditChatIcon } from '../svg/reddit-chat.svg'
export { ReactComponent as RefferralsProfileIcon } from '../svg/refferralsProfile.svg'
export { ReactComponent as ReportIcoIcon } from '../svg/report-ico.svg'
export { ReactComponent as RewardsApplepayIcon } from '../svg/rewards-applepay.svg'
export { ReactComponent as RewardsCard1Icon } from '../svg/rewards-card-1.svg'
export { ReactComponent as RewardsCard2Icon } from '../svg/rewards-card-2.svg'
export { ReactComponent as RewardsCard3Icon } from '../svg/rewards-card-3.svg'
export { ReactComponent as RewardsCard4Icon } from '../svg/rewards-card-4.svg'
export { ReactComponent as RewardsCard5Icon } from '../svg/rewards-card-5.svg'
export { ReactComponent as RewardsGpayIcon } from '../svg/rewards-gpay.svg'
export { ReactComponent as RewardsMastercardIcon } from '../svg/rewards-mastercard.svg'
export { ReactComponent as RewardsSamsungpayIcon } from '../svg/rewards-samsungpay.svg'
export { ReactComponent as RollerCoasterIcon } from '../svg/roller-coaster.svg'
export { ReactComponent as RugbyBIcon } from '../svg/rugbyB.svg'
export { ReactComponent as ScratchCardIcon } from '../svg/Scratch Card.svg'
export { ReactComponent as SearchIconIcon } from '../svg/search-icon.svg'
export { ReactComponent as SettingProfileIcon } from '../svg/settingProfile.svg'
export { ReactComponent as SliderLeftArrowGreyIcon } from '../svg/slider-left-arrow-grey.svg'
export { ReactComponent as SliderLeftArrowIcon } from '../svg/slider-left-arrow.svg'
export { ReactComponent as SliderRightArrowGreyIcon } from '../svg/slider-right-arrow-grey.svg'
export { ReactComponent as SliderRightArrowIcon } from '../svg/slider-right-arrow.svg'
export { ReactComponent as SliderStripeIcon } from '../svg/slider-stripe.svg'
export { ReactComponent as SliderThumbIcon } from '../svg/slider-thumb.svg'
export { ReactComponent as SlotGameIcon } from '../svg/Slot Game.svg'
export { ReactComponent as SlotDIcon } from '../svg/slot-D.svg'
export { ReactComponent as SlotWIcon } from '../svg/slot-W.svg'
export { ReactComponent as SoccerIcon } from '../svg/soccer.svg'
export { ReactComponent as SocialCrossIcon } from '../svg/social-cross.svg'
export { ReactComponent as SocialIcon2Icon } from '../svg/social-icon-2.svg'
export { ReactComponent as SocialLink3Icon } from '../svg/social-link-3.svg'
export { ReactComponent as SocialLink4Icon } from '../svg/social-link-4.svg'
export { ReactComponent as SocialTwitchIconNewIcon } from '../svg/social-twitch-icon-new.svg'
export { ReactComponent as SocialIcon } from '../svg/social.svg'
export { ReactComponent as SolanaIcon } from '../svg/solana.svg'
export { ReactComponent as SportsMenuIcon } from '../svg/Sports-menu.svg'
export { ReactComponent as SportsbookFavouritesIcon } from '../svg/sportsbookFavourites.svg'
export { ReactComponent as SportsBSoccerIcon } from '../svg/sportsBSoccer.svg'
export { ReactComponent as StatisticsIcon } from '../svg/statistics.svg'
export { ReactComponent as SteamChatIcon } from '../svg/steam-chat.svg'
export { ReactComponent as TableGameIcon } from '../svg/Table Game.svg'
export { ReactComponent as TableContentLoaderIcon } from '../svg/tableContentLoader.svg'
export { ReactComponent as TableTennisIcon } from '../svg/tableTennis.svg'
export { ReactComponent as TableTennisBIcon } from '../svg/tableTennisB.svg'
export { ReactComponent as TelegramIcon } from '../svg/telegram.svg'
export { ReactComponent as TennisIcon } from '../svg/tennis.svg'
export { ReactComponent as TennisBIcon } from '../svg/tennisB.svg'
export { ReactComponent as TipsIcon } from '../svg/tips.svg'
export { ReactComponent as TombalaIcon } from '../svg/Tombala.svg'
export { ReactComponent as TransactionIcon } from '../svg/Transaction.svg'
export { ReactComponent as TrueIcon } from '../svg/true.svg'
export { ReactComponent as TwitchChatIcon } from '../svg/twitch-chat.svg'
export { ReactComponent as TwitchColorIcon } from '../svg/twitch-color.svg'
export { ReactComponent as TwitchIconNewIcon } from '../svg/twitch-icon-new.svg'
export { ReactComponent as TwitchIconIcon } from '../svg/twitch-icon.svg'
export { ReactComponent as TwitchIcon } from '../svg/twitch.svg'
export { ReactComponent as TwitchSquareIcon } from '../svg/twitchSquare.svg'
export { ReactComponent as TwitterChatIcon } from '../svg/twitter-chat.svg'
export { ReactComponent as TwitterIcon } from '../svg/twitter.svg'
export { ReactComponent as UiChartIcon } from '../svg/ui-chart.svg'
export { ReactComponent as UploadFilesIcon } from '../svg/upload-files.svg'
export { ReactComponent as VectorIcon } from '../svg/Vector.svg'
export { ReactComponent as VerificationIcon } from '../svg/Verification.svg'
export { ReactComponent as VideoBingoIcon } from '../svg/Video bingo.svg'
export { ReactComponent as VideoPokerIcon } from '../svg/Video Poker.svg'
export { ReactComponent as VideoSlotIcon } from '../svg/Video Slot.svg'
export { ReactComponent as VirtualGameIcon } from '../svg/virtual game.svg'
export { ReactComponent as VolleyballIcon } from '../svg/volleyball.svg'
export { ReactComponent as VolleyballBIcon } from '../svg/volleyballB.svg'
export { ReactComponent as VolumIcon } from '../svg/volum.svg'
export { ReactComponent as WalletIcoIcon } from '../svg/wallet-ico.svg'
export { ReactComponent as WalletIcon } from '../svg/wallet.svg'
export { ReactComponent as WhiteDownIcon } from '../svg/white-down.svg'
export { ReactComponent as WithdrawalIcon } from '../svg/withdrawal.svg'
export { ReactComponent as RightArrowCircleIcon } from '../svg/arrow-right-filled.svg'
export { ReactComponent as LeftArrowCircleIcon } from '../svg/arrow-left-filled.svg'
export { ReactComponent as GreenCircleIcon } from './green-circle.svg'
export { ReactComponent as GrowUpArrowIcon } from './grow-up-arrow.svg'
export { ReactComponent as PrivateIcon } from './private-icon.svg'
export { ReactComponent as PlusFilledIcon } from './plus_filled.svg'
export { ReactComponent as MinusCircleIcon } from './minus-circle-icon.svg'
export { ReactComponent as PlusCircleIcon } from './plus-circle-icon.svg'

export { ReactComponent as UpArrowIcon } from './up-arrow.svg'
export { ReactComponent as DownArrowIcon } from './down-arrow.svg'
export { ReactComponent as HitIcon } from './hit.svg'
export { ReactComponent as CrossIcon } from './cross-icon.svg'
export { ReactComponent as StandIcon } from './stand-icon.svg'
export { ReactComponent as SplitIcon } from './split-icon.svg'
export { ReactComponent as DoubleIcon } from './double-icon.svg'
export { ReactComponent as WarningIcon } from './icon-warning.svg'
export { ReactComponent as UpDownArrowIcon } from './up-down-arrow.svg'
export { ReactComponent as VolumeMuteIcon } from './volume-mute.svg'
export { ReactComponent as VolumeUnMuteIcon } from './volume-unmute.svg'
export { ReactComponent as KeyboardIcon } from './keyboard.svg'
export { ReactComponent as StateRefreshIcon } from './icon-refresh.svg'
